module.exports = __webpack_public_path__ + "static/media/landing_1440.6970b874.jpg";